import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import './ourservice.modules.css'; // Import custom CSS for styling
import plan from "../../../images/Travelicons/planpng.png";
import price from "../../../images/Travelicons/saveMony.png";
import service from "../../../images/Travelicons/service.png";
import sebit from "../../../images/Travelicons/paymentpng.png";

const OurServices = () => {
  return (
    <Container className="why-champs-travel my-5 ">
      <h1 className="text-center mb-4">Why Champs Travel is your Best Choice</h1>
      <Row className="pt-3">
        {/* Card 1: Muslim Family Travel */}
        <Col md={3} sm={6} className="mb-4">
          <Card className="feature-card h-100">
            <Card.Body>
              <div className="d-flex align-items-center">
                <img src={plan} className="card-icon" alt="Muslim Family Travel" />
                <Card.Title className="ps-3">Muslim Halal Vacations</Card.Title>
              </div>
              <Card.Text className="ps-5 ms-4">
                Explore faith-friendly destinations. Make memories that matter.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>

        {/* Card 2: Best Price – Best Quality */}
        <Col md={3} sm={6} className="mb-4">
          <Card className="feature-card h-100">
            <Card.Body>
              <div className="d-flex align-items-center">
                <img src={price} className="card-icon" alt="Best Price – Best Quality" />
                <Card.Title className="ps-3">Premium Travel, Elite Experiences</Card.Title>
              </div>
              <Card.Text className="ps-5 ms-4">
              Affordable luxury, curated for Muslim families.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>

        {/* Card 3: Outstanding Customer Care */}
        <Col md={3} sm={6} className="mb-4">
          <Card className="feature-card h-100">
            <Card.Body>
              <div className="d-flex align-items-center">
                <img src={service} className="card-icon" alt="Outstanding Customer Care" />
                <Card.Title className="ps-3 mb-0">Exceptional Care, Every Step of the way</Card.Title>
              </div>
              <Card.Text className="ps-5 ms-4">
              Personalized service, Multilingual support. Your journey, our priority.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>

        {/* Card 4: Online Booking System */}
        <Col md={3} sm={6} className="mb-4">
          <Card className="feature-card h-100">
            <Card.Body>
              <div className="d-flex align-items-center">
                <img src={sebit} className="card-icon" alt="Online Booking System" />
                <Card.Title className="ps-3">Flexible Payment Plans, Hassle-Free Travel </Card.Title>
              </div>
              <Card.Text className="ps-5 ms-4">
              Convenient installments and easy facilitations to bring your halal travel dreams to life.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default OurServices;